import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {TeamModel} from '../../../models/api/teamModel';
import {TeamAvatar} from '../avatars/teamAvatar';

/*
 * Props.
 */

interface DropdownItemTeamAvatarProps {
  team: TeamModel;
}

/*
 * Style.
 */

const StyledAvatarDiv = styled.div`
  grid-area: left-icon;
  margin-right: 8px;
  align-self: center;
`;

/*
 * Component.
 */

export const DropdownItemTeamAvatar: FC<DropdownItemTeamAvatarProps> = ({team}) => (
  <StyledAvatarDiv>
    <TeamAvatar team={team} size={VisualSizesEnum.MEDIUM} />
  </StyledAvatarDiv>
);
